// /* global gettext */

class FactsTableController {
}

export function FactsTableComponent() {
  return {
    restrict: 'E',
    scope: false,
    template: require('./facts-table.component.html'),
    controller: FactsTableController,
  };
}



// WEBPACK FOOTER //
// ./src/facts/facts-table.component.js